module.exports = __webpack_public_path__ + "static/media/ReportWhite.ca0f2d42.png";